/* eslint-disable no-console */
import { sendDealerAvailabilityLeadToDrip } from '../drip-helpers';
import { setUserSignUpStatus } from './email-signup-status';
import { clearInputValues, removeAllErrors, validate } from '../../utils/form-validation-utils';

const clearEmailSignupFormData = () => {
  const form = document.querySelector('.email-signup-form');
  removeAllErrors(form);
  clearInputValues(form);
};

const initEmailSignupForm = () => {
  const modalDiv = document.querySelector('.dealer-availability-modal');
  const form = document.querySelector('.email-signup-form');
  const formError = form.querySelector('.form-error-message');
  const submitBtn = form.querySelector('.submit-btn');
  // Add look-up zipcode to form
  const availabilityZipCode = document.getElementById('availabilityZipCode');
  const lookupZipCode = form.querySelector('#lookupZipCode');
  lookupZipCode.value = availabilityZipCode.value;

  const updateModalHeight = () => {
    const contentHeight = modalDiv.querySelector('.modal-content').offsetHeight;
    modalDiv.querySelector('.modal-panel').style.height = `${contentHeight + 30}px`;
  };

  const showThankYouState = () => {
    modalDiv.querySelector('.no-dealer-state').classList.add('hidden');
    modalDiv.querySelector('.email-signup-form').classList.add('hidden');
    modalDiv.querySelector('.thank-you-state').classList.remove('hidden');
    modalDiv.querySelector('.thank-you-state h2').focus();
  };

  const disableSubmitBtn = () => {
    submitBtn.setAttribute('disabled', 'disabled');
    submitBtn.value = 'Sending...';
  };

  const enableSubmitBtn = () => {
    submitBtn.removeAttribute('disabled');
    submitBtn.value = 'Submit';
  };

  const showFormError = () => {
    formError.classList.remove('hidden');
    updateModalHeight();
    formError.focus();
  };

  const hideFormError = () => {
    formError.classList.add('hidden');
    updateModalHeight();
  };

  submitBtn.addEventListener('click', (event) => {
    event.preventDefault();
    removeAllErrors(form);
    hideFormError();
    if (validate(form)) {
      disableSubmitBtn();
      sendDealerAvailabilityLeadToDrip(form, {
        success: () => {
          setUserSignUpStatus('yes');
          showThankYouState();
          updateModalHeight();
          enableSubmitBtn();
        },
        fail: (data) => {
          console.log(data);
          enableSubmitBtn();
          showFormError();
          enableSubmitBtn();
        },
      });
    } else {
      updateModalHeight();
    }
  });
};

const updateEmalSignupForm = (options) => {
  const { email } = options;
  const emailIpt = document.querySelector('#availabilityEmail');
  if (emailIpt) {
    emailIpt.value = email;
  }
};

export {
  clearEmailSignupFormData,
  initEmailSignupForm,
  updateEmalSignupForm,
};
/* eslint-enable no-console */
